<form nz-form *ngIf="mainformGroup" [formGroup]="mainformGroup" [nzLayout]="'vertical'">
    <div class="edit-panel">
        <div class="edit-panel-action">
            <button nz-button nzSize="small" (click)="clearRow()" class="search-button">{{'reset'|translateTA}}</button>
            <div class="title-section">{{field.label|translateTA}}</div>
        </div>
        <div class="edit-panel-container">
            <div nz-row *ngFor="let row of formRows" [nzGutter]="16">
                <nz-col *ngFor="let item of field.sectionConfiguration.fields|arrayFilter:'row':row.toString():false" [nzSpan]="item.colSpan" [nzOrder]="field.col">
                    <webhook-common [mainformGroup]="newRow" [field]="item" [variables]="variables"   [configuration]="configuration"  [rootForm]="newRow" > </webhook-common>
                </nz-col>
            </div>
        </div>        
    </div>
</form>

